// main.js

import "./main.scss";

import "./scripts/utils/Dialog.js";
import "./scripts/utils/Tooltip.js";
import "./scripts/utils/SyncedInputs.js";

import "./scripts/components/Accordion.js";
import "./scripts/components/AnnouncementBanner.js";
import "./scripts/components/CogCredits.js";
import "./scripts/components/CogBooking.js";
import "./scripts/components/LoadMore.js";
import "./scripts/components/FieldSizing.js";
import "./scripts/components/LoadingIndicator.js";
import "./scripts/components/QuantityInput.js";
import "./scripts/components/SiteHeader.js";
import "./scripts/components/SingleSelectGroup.js";
import SpektrixSession from "./scripts/components/SpektrixSession.js";
import "./scripts/components/SpektrixIframe.js";
import "./scripts/components/ExpandableList.js";
import "./scripts/components/HomeBanner.js";
import "./scripts/components/MediaGallery.js";
import "./scripts/components/GoogleMapsStatic.js";
import "./scripts/components/NumberedPagination.js";

// Flex Blocks
import "./scripts/components/flex/Support.js";

document.addEventListener("DOMContentLoaded", () => {
    new SpektrixSession();
});
